import { useQuery } from "@/api/swr/useQuery";
import { improvementProposalSchema } from "@/schema/improvement-proposal/ImprovementProposal";

type Config = Parameters<typeof useQuery<typeof improvementProposalSchema>>[2];

export function useGetImprovementProposal(id: string, config?: Config) {
  return useQuery(
    improvementProposalSchema,
    `/app/improvement_proposals/${id}`,
    config,
  );
}
